export default __webpack_public_path__ + "static/media/accj.570f4987.jpg";